module.exports = __webpack_public_path__ + "img/share_icon1.acff3013.png";